// extracted by css-extract-rspack-plugin
export default {"input":"NumberInput-module__input___xE_vM","error":"NumberInput-module__error___LFOFf"};